@import '../../styles/deprecatedBreakpoints';

.checkout-backdrop {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

.checkout-paper.no-scroll {
  overflow: hidden;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  &.right-drawer {
    border-radius: 0;
    overflow-y: auto;
  }

  &.full-height {
    border-radius: 0;
  }

  &:not(.right-drawer) {
    @include breakpoint('large') {
      max-width: 1400px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 20px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: none !important;
    }
  }
}
